import { useQuery } from "@tanstack/react-query";
import { adaptRegions } from "src/features/Locations/adapters/adaptRegion";
import cmsClient from "src/services/cmsClient";

const fetchRegions = async () => {
	const response = await cmsClient.get<IRegion[]>(
		"/homepage/admin/store/region/"
	);

	return response.data;
};

const useAdminRegions = () => {
	return useQuery(["admin-regions"], fetchRegions, {
		select: adaptRegions,
		staleTime: 10 * 60 * 1000
	});
};

export default useAdminRegions;
